import {h, Component} from 'preact';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import {mapRootUrl} from '@util/URLUtils';
import assign from 'object-assign';
import {cxMenu, nav} from '../styles';
import Header from './Header';
import GroupLabel from './GroupLabel';
import Item from './Item';
import ItemGroup from './ItemGroup';
import ItemNode from './ItemNode';
import ItemLeaf from './ItemLeaf';
import MediaItem from './MediaItem';

function renderMenuItem ( node ) {
    const props = assign( {}, node );

    // we check for "chemistries" route to determine which menu layout to render
    // "chemistries" is the only menu with a custom layout at time of creation
    const Component = /chemistries/.test( node.url ) && node.image
        ? Menu.mediaItem
        : Menu.item;
    return <Component {...props} />
}

class Menu extends Component {

    static header = Header;
    static groupLabel = GroupLabel;
    static item = Item;
    static itemGroup = ItemGroup;
    static itemNode = ItemNode;
    static itemLeaf = ItemLeaf;
    static mediaItem = MediaItem;

    render ( {sysId, title, url, children = []} ) {
        return (
            <nav data-menu-id={sysId}
                 data-state="offcanvas"
                 data-menu-unviewed="true"
                 className={`nav-menu-collection--mobile ${ nav.primary }`}>
                <ul className={`nav-group-primary--mobile ${ cxMenu.list }`}>
                    <Header>{title}</Header>
                    {!isEmptyOrNil( children ) && children.map( mapRootUrl( {url} ) ).map( renderMenuItem )}
                </ul>
            </nav>
        )
    }
}

export default Menu;